<template>
  <div style="position: relative;">
    <el-form ref="flowRequirementRelateAuditList" :model="flowRequirementRelateAuditList" label-width="100px" :size="defaultFormItemSize" label-position="right" @submit.native.prevent>
      <filter-box :item-width="350">
        <el-form-item label="工单状态" prop="formFilter.flowStatus">
          <el-select class="filter-item" v-model="flowRequirementRelateAuditList.formFilter.flowStatus" :clearable="true"
                     placeholder="工单状态">
            <el-option v-for="item in SysFlowWorkOrderStatus.getList()" :key="item.id"
                       :label="item.name" :value="item.id"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="创建日期" prop="formFilter.createTime">
          <date-range class="filter-item" v-model="flowRequirementRelateAuditList.formFilter.createTime" :clearable="true" :allowTypes="['day']" align="left"
                      range-separator="-" start-placeholder="开始日期" end-placeholder="结束日期"
                      format="yyyy-MM-dd" value-format="yyyy-MM-dd HH:mm:ss" />
        </el-form-item>
        <el-form-item label="工单编号" prop="formFilter.workOrderCode">
          <el-input class="filter-item" v-model="flowRequirementRelateAuditList.formFilter.workOrderCode"
                    :clearable="true" placeholder="工单编号"
          />
        </el-form-item>
        <el-button slot="operator" type="default" :plain="true" :size="defaultFormItemSize" @click="onReset">重置</el-button>
        <el-button slot="operator" type="primary" :plain="true" :size="defaultFormItemSize" @click="refreshFlowRequirementRelateAuditList(true)">查询</el-button>
<!--        <el-button slot="operator" type="primary" :size="defaultFormItemSize"-->
<!--                   @click="onStartTaskClick()">-->
<!--          新建-->
<!--        </el-button>-->
      </filter-box>
    </el-form>
    <el-row>
      <el-col :span="24">
        <el-table ref="requirementRelate" :data="requirementRelateWidget.dataList" :size="defaultFormItemSize"
                  @sort-change="requirementRelateWidget.onSortChange"
                  header-cell-class-name="table-header-gray">
          <el-table-column label="序号" header-align="center" align="center" type="index" width="55px"
                           :index="requirementRelateWidget.getTableIndex"
          />
          <el-table-column label="工单编号" prop="workOrderCode" />
          <el-table-column label="需求主题" prop="masterData.subjectName">
          </el-table-column>
          <el-table-column label="对接专家" prop="masterData.specialistIdDictMap.name">
          </el-table-column>
          <el-table-column label="当前任务" prop="runtimeTaskInfo.taskName" />
          <el-table-column label="流程创建时间" prop="createTime" />
          <el-table-column label="流程状态" prop="latestApprovalStatusDictMap.name" width="100px" />
          <el-table-column label="工单状态" prop="flowStatus"  width="100px">
            <template slot-scope="scope">
              <span>{{SysFlowWorkOrderStatus.getValue(scope.row.flowStatus)}}</span>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="150px" fixed="right">
            <template slot-scope="scope">
              <el-button type="text" :size="defaultFormItemSize"
                         v-if="(scope.row.initTaskInfo || {}).taskKey !== (scope.row.runtimeTaskInfo || {}).taskKey"
                         @click.stop="onViewTaskClick(scope.row)">
                详情
              </el-button>
              <el-button type="text" :size="defaultFormItemSize"
                         v-if="(scope.row.initTaskInfo || {}).taskKey === (scope.row.runtimeTaskInfo || {}).taskKey"
                         @click.stop="onHandlerTaskClick(scope.row)">
                办理
              </el-button>
              <el-button type="text" :size="defaultFormItemSize" class="table-btn"
                         @click.stop="onRemindClick(scope.row)">
                催办
              </el-button>
              <el-button type="text" :size="defaultFormItemSize" class="table-btn error"
                         @click.stop="onCancelTaskClick(scope.row)">
                撤销
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import '@/staticDict/flowStaticDict.js';
/* eslint-disable-next-line */
  import { DropdownWidget, TableWidget, UploadWidget, ChartWidget } from '@/utils/widget.js';
/* eslint-disable-next-line */
  import { uploadMixin, statsDateRangeMixin, cachePageMixin } from '@/core/mixins';
/* eslint-disable-next-line */
  import { RequirementRelateController, DictionaryController } from '@/api';
/* eslint-disable-next-line */
  import { FlowOperationController } from '@/api/flowController.js';

const processDefinitionKey = 'flowRequirementRelateAudit';
const processDefinitionName = '需求对接审批流程';

export default {
  name: 'flowRequirementRelateAuditList',
  props: {
  },
  mixins: [uploadMixin, statsDateRangeMixin, cachePageMixin],
  data () {
    return {
      flowRequirementRelateAuditList: {
        formFilter: {
          flowStatus: undefined,
          workOrderCode: undefined,
          createTime: []
        },
        formFilterCopy: {
          flowStatus: undefined,
          workOrderCode: undefined,
          createTime: []
        },
        isInit: false
      },
      requirementRelateWidget: new TableWidget(this.loadRequirementRelateData, this.loadRequirementRelateVerify, false)
    }
  },
  methods: {
    onReset () {
      this.$refs.flowRequirementRelateAuditList.resetFields();
      this.refreshFlowRequirementRelateAuditList(true);
    },
    loadRequirementRelateData (params) {
      if (params == null) params = {};
      params = {
        ...params,
        flowWorkOrderDtoFilter: {
          flowStatus: this.flowRequirementRelateAuditList.formFilterCopy.flowStatus,
          workOrderCode: this.flowRequirementRelateAuditList.formFilterCopy.workOrderCode,
          createTimeStart: Array.isArray(this.flowRequirementRelateAuditList.formFilterCopy.createTime) ? this.flowRequirementRelateAuditList.formFilterCopy.createTime[0] : undefined,
          createTimeEnd: Array.isArray(this.flowRequirementRelateAuditList.formFilterCopy.createTime) ? this.flowRequirementRelateAuditList.formFilterCopy.createTime[1] : undefined
        }
      }
      return new Promise((resolve, reject) => {
        RequirementRelateController.listWorkOrderFlowRequirementRelateAudit(this, params).then(res => {
          let dataList = res.data.dataList.map(item => {
            item.initTaskInfo = JSON.parse(item.initTaskInfo);
            item.runtimeTaskInfo = Array.isArray(item.runtimeTaskInfoList) ? item.runtimeTaskInfoList[0] : undefined;
            item.masterData = item.masterData || {};
            return item;
          });
          resolve({
            dataList: dataList,
            totalCount: res.data.totalCount
          });
        }).catch(e => {
          reject(e);
        })
      });
    },
    loadRequirementRelateVerify () {
      this.flowRequirementRelateAuditList.formFilterCopy.flowStatus = this.flowRequirementRelateAuditList.formFilter.flowStatus;
      this.flowRequirementRelateAuditList.formFilterCopy.workOrderCode = this.flowRequirementRelateAuditList.formFilter.workOrderCode;
      this.flowRequirementRelateAuditList.formFilterCopy.createTime = this.flowRequirementRelateAuditList.formFilter.createTime;
      return true;
    },
    // 启动流程
    onStartTaskClick () {
      let params = {
        processDefinitionKey: processDefinitionKey
      }

      FlowOperationController.viewInitialTaskInfo(this, params).then(res => {
        if (res.data && res.data.taskType === this.SysFlowTaskType.USER_TASK && res.data.assignedMe) {
          this.$router.push({
            name: res.data.routerName || 'handlerFlowTask',
            query: {
              processDefinitionKey: processDefinitionKey,
              formId: res.data.formId,
              routerName: res.data.routerName,
              readOnly: res.data.readOnly,
              taskName: '启动流程',
              isDraft: true,
              flowEntryName: processDefinitionName,
              variableList: res.data.variableList,
              operationList: (res.data.operationList || []).filter(item => {
                return item.type !== this.SysFlowTaskOperationType.CO_SIGN && item.type !== this.SysFlowTaskOperationType.REVOKE;
              })
            }
          });
        } else {
          FlowOperationController.startOnly(this, {
            processDefinitionKey: processDefinitionKey
          }).then(res => {
            this.$message.success('启动成功！');
          }).catch(e => {});
        }
      }).catch(e => {});
    },
    // 办理流程
    onHandlerTaskClick (row) {
      let taskId = (Array.isArray(row.runtimeTaskInfoList) && row.runtimeTaskInfoList.length > 0) ? row.runtimeTaskInfoList[0].taskId : undefined;
      let params = {
        processInstanceId: row.processInstanceId,
        processDefinitionId: row.processDefinitionId,
        taskId: taskId
      }

      FlowOperationController.viewRuntimeTaskInfo(this, params).then(res => {
        if (res.data) {
          this.$router.push({
            name: res.data.routerName || 'handlerFlowTask',
            query: {
              isRuntime: true,
              isDraft: row.flowStatus === this.SysFlowWorkOrderStatus.DRAFT,
              taskId: taskId,
              processDefinitionKey: processDefinitionKey,
              processInstanceId: row.processInstanceId,
              processDefinitionId: row.processDefinitionId,
              formId: res.data.formId,
              routerName: res.data.routerName,
              readOnly: res.data.readOnly,
              taskName: (row.runtimeInitialTask || {}).taskName,
              flowEntryName: row.processDefinitionName,
              processInstanceInitiator: row.processInstanceInitiator,
              operationList: (res.data.operationList || []).filter(item => {
                return item.type !== this.SysFlowTaskOperationType.CO_SIGN && item.type !== this.SysFlowTaskOperationType.REVOKE;
              }),
              variableList: res.data.variableList
            }
          });
        }
      }).catch(e => {});
    },
    // 查看流程
    onViewTaskClick (row) {
      let params = {
        processInstanceId: row.processInstanceId
      }
      let taskId = (Array.isArray(row.runtimeTaskInfoList) && row.runtimeTaskInfoList.length > 0) ? row.runtimeTaskInfoList[0].taskId : undefined;
      FlowOperationController.viewInitialHistoricTaskInfo(this, params).then(res => {
        if (res.data) {
          this.$router.push({
            name: res.data.routerName || 'handlerFlowTask',
            query: {
              isRuntime: false,
              taskId: taskId,
              processDefinitionKey: row.processDefinitionKey,
              processInstanceId: row.processInstanceId,
              processDefinitionId: row.processDefinitionId,
              routerName: res.data.routerName,
              readOnly: true,
              flowEntryName: row.processDefinitionName,
              processInstanceInitiator: row.processInstanceInitiator
            }
          });
        }
      }).catch(e => {});
    },
    // 催办
    onRemindClick (row) {
      FlowOperationController.remindRuntimeTask(this, {
        workOrderId: row.workOrderId
      }).then(res => {
        this.$message.success('催办成功');
      }).catch(e => {});
    },
    // 撤销流程
    onCancelTaskClick (row) {
      this.$confirm('是否撤销此工单？').then(res => {
        let params = {
          workOrderId: row.workOrderId,
          cancelReason: '主动撤销'
        }

        FlowOperationController.cancelWorkOrder(this, params).then(res => {
          this.$message.success('撤销成功！');
          this.refreshFlowRequirementRelateAuditList();
        }).catch(e => {});
      }).catch(e => {});
    },
    // 刷新工单
    refreshFlowRequirementRelateAuditList (reloadData = false) {
      if (reloadData) {
        this.requirementRelateWidget.refreshTable(true, 1);
      } else {
        this.requirementRelateWidget.refreshTable();
      }
      if (!this.flowRequirementRelateAuditList.isInit) {
        // 初始化下拉数据
      }
      this.flowRequirementRelateAuditList.isInit = true;
    },
    onResume () {
      this.refreshFlowRequirementRelateAuditList();
    },
    formInit () {
      this.refreshFlowRequirementRelateAuditList();
    }
  },
  mounted () {
    // 初始化页面数据
    this.formInit();
  },
  watch: {
  }
}
</script>

<style>
</style>
